/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, {lazy} from 'react'
import {Redirect} from 'react-router-dom'
import AuthLayout from './layouts/Auth'
import ErrorLayout from './layouts/Error'
import DashboardLayout from './layouts/Dashboard'

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard"/>
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      /* START_ROUTES */{
        path: '/lawyer/courses',
        exact: true,
        component: lazy(() => import('src/views/LawyerCourses'))
      },{
        path: '/lawyer/courses/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerCourses/LawyerCoursesDetails'))
      },{
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('src/views/Dashboard'))
      },{
        path: '/profile',
        exact: true,
        component: lazy(() => import('src/views/Dashboard/DashboardLawyer'))
      },{
        path: '/clients',
        exact: true,
        component: lazy(() => import('src/views/Clients'))
      },{
        path: '/clients/:id',
        exact: true,
        component: lazy(() => import('src/views/Clients/ClientsDetails'))
      },{
        path: '/lawyers',
        exact: true,
        component: lazy(() => import('src/views/Lawyers'))
      },{
        path: '/lawyers/:id',
        exact: true,
        component: lazy(() => import('src/views/Lawyers/LawyersDetails'))
      },{
        path: '/orders',
        exact: true,
        component: lazy(() => import('src/views/Orders'))
      },{
        path: '/orders/advice',
        exact: true,
        component: lazy(() => import('src/views/OrdersAdvice'))
      },{
        path: '/orders/advice/:id',
        exact: true,
        component: lazy(() => import('src/views/OrdersAdvice/OrdersAdviceDetails'))
      },{
        path: '/orders/issue',
        exact: true,
        component: lazy(() => import('src/views/OrdersIssue'))
      },{
        path: '/orders/issue/:id',
        exact: true,
        component: lazy(() => import('src/views/OrdersIssue/OrdersIssueDetails'))
      },{
        path: '/refuseoffers',
        exact: true,
        component: lazy(() => import('src/views/Refuseoffers'))
      },{
        path: '/refuseoffers/:id',
        exact: true,
        component: lazy(() => import('src/views/Refuseoffers/RefuseoffersDetails'))
      },{
        path: '/refused',
        exact: true,
        component: lazy(() => import('src/views/Refused'))
      },{
        path: '/refused/:id',
        exact: true,
        component: lazy(() => import('src/views/Refused/RefusedDetails'))
      },{
        path: '/rates',
        exact: true,
        component: lazy(() => import('src/views/Rates'))
      },{
        path: '/rates/clients',
        exact: true,
        component: lazy(() => import('src/views/RatesClients'))
      },{
        path: '/rates/clients/:id',
        exact: true,
        component: lazy(() => import('src/views/RatesClients/RatesClientsDetails'))
      },{
        path: '/rates/lawyers',
        exact: true,
        component: lazy(() => import('src/views/RatesLawyers'))
      },{
        path: '/rates/lawyers/:id',
        exact: true,
        component: lazy(() => import('src/views/RatesLawyers/RatesLawyersDetails'))
      },{
        path: '/balances',
        exact: true,
        component: lazy(() => import('src/views/Balances'))
      },{
        path: '/balances/:id',
        exact: true,
        component: lazy(() => import('src/views/Balances/BalancesDetails'))
      },{
        path: '/reports',
        exact: true,
        component: lazy(() => import('src/views/Reports'))
      },{
        path: '/reports/:id',
        exact: true,
        component: lazy(() => import('src/views/Reports/ReportsDetails'))
      },{
        path: '/settings',
        exact: true,
        component: lazy(() => import('src/views/Settings'))
      },{
        path: '/settings/general',
        exact: true,
        component: lazy(() => import('src/views/SettingsGeneral'))
      },{
        path: '/settings/general/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsGeneral/SettingsGeneralDetails'))
      },{
        path: '/settings/questions',
        exact: true,
        component: lazy(() => import('src/views/SettingsQuestions'))
      },{
        path: '/settings/questions/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsQuestions/SettingsQuestionsDetails'))
      },{
        path: '/settings/countries',
        exact: true,
        component: lazy(() => import('src/views/SettingsCountries'))
      },{
        path: '/settings/countries/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsCountries/SettingsCountriesDetails'))
      },{
        path: '/settings/cities',
        exact: true,
        component: lazy(() => import('src/views/SettingsCities'))
      },{
        path: '/settings/cities/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsCities/SettingsCitiesDetails'))
      },{
        path: '/settings/languages',
        exact: true,
        component: lazy(() => import('src/views/SettingsLanguages'))
      },{
        path: '/settings/languages/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsLanguages/SettingsLanguagesDetails'))
      },{
        path: '/settings/degrees',
        exact: true,
        component: lazy(() => import('src/views/SettingsDegrees'))
      },{
        path: '/settings/degrees/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsDegrees/SettingsDegreesDetails'))
      },{
        path: '/settings/specialties',
        exact: true,
        component: lazy(() => import('src/views/SettingsSpecialties'))
      },{
        path: '/settings/specialties/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsSpecialties/SettingsSpecialtiesDetails'))
      },{
        path: '/settings/levels',
        exact: true,
        component: lazy(() => import('src/views/SettingsLevels'))
      },{
        path: '/settings/levels/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsLevels/SettingsLevelsDetails'))
      },{
        path: '/settings/banks',
        exact: true,
        component: lazy(() => import('src/views/SettingsBanks'))
      },{
        path: '/settings/banks/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsBanks/SettingsBanksDetails'))
      },{
        path: '/lawyer',
        exact: true,
        component: lazy(() => import('src/views/Lawyer'))
      },{
        path: '/lawyer/profile',
        exact: true,
        component: lazy(() => import('src/views/LawyerProfile'))
      },{
        path: '/lawyer/profile/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerProfile/LawyerProfileDetails'))
      },{
        path: '/lawyer/experiences',
        exact: true,
        component: lazy(() => import('src/views/LawyerExperiences'))
      },{
        path: '/lawyer/experiences/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerExperiences/LawyerExperiencesDetails'))
      },{
        path: '/lawyer/qualifications',
        exact: true,
        component: lazy(() => import('src/views/LawyerQualifications'))
      },{
        path: '/lawyer/qualifications/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerQualifications/LawyerQualificationsDetails'))
      },{
        path: '/lawyer/licenses',
        exact: true,
        component: lazy(() => import('src/views/LawyerLicenses'))
      },{
        path: '/lawyer/licenses/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerLicenses/LawyerLicensesDetails'))
      },{
        path: '/lawyer/memberships',
        exact: true,
        component: lazy(() => import('src/views/LawyerMemberships'))
      },{
        path: '/lawyer/memberships/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerMemberships/LawyerMembershipsDetails'))
      },{
        path: '/lawyer/change-password',
        exact: true,
        component: lazy(() => import('src/views/LawyerAccount'))
      },{
        path: '/lawyer/account/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerAccount/LawyerAccountDetails'))
      },{
        path: '/lawyer/rate',
        exact: true,
        component: lazy(() => import('src/views/LawyerRate'))
      },{
        path: '/lawyer/rate/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerRate/LawyerRateDetails'))
      },{
        path: '/invitations',
        exact: true,
        component: lazy(() => import('src/views/Invitations'))
      },{
        path: '/invitations/:id',
        exact: true,
        component: lazy(() => import('src/views/Invitations/InvitationsDetails'))
      },{
        path: '/messages/:id',
        exact: true,
        component: lazy(() => import('src/views/Messages'))
      },{
        path: '/lawyerorders/advice',
        exact: true,
        component: lazy(() => import('src/views/LawyerordersAdvice'))
      },{
        path: '/lawyerorders/advice/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerordersAdvice/LawyerordersAdviceDetails'))
      },{
        path: '/lawyerorders/issue',
        exact: true,
        component: lazy(() => import('src/views/LawyerordersIssue'))
      },{
        path: '/lawyerorders/issue/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerordersIssue/LawyerordersIssueDetails'))
      },{
        path: '/lawyerorders/offer',
        exact: true,
        component: lazy(() => import('src/views/LawyerordersOffer'))
      },{
        path: '/lawyerorders/offer/:id',
        exact: true,
        component: lazy(() => import('src/views/LawyerordersOffer/LawyerordersOfferDetails'))
      },{
        path: '/archive',
        exact: true,
        component: lazy(() => import('src/views/Archive'))
      },{
        path: '/archive/:id',
        exact: true,
        component: lazy(() => import('src/views/Archive/ArchiveDetails'))
      },{
        path: '/lawyerbalance',
        exact: true,
        component: lazy(() => import('src/views/Lawyerbalance'))
      },{
        path: '/lawyerbalance/:id',
        exact: true,
        component: lazy(() => import('src/views/Lawyerbalance/LawyerbalanceDetails'))
      },{
        path: '/users',
        exact: true,
        component: lazy(() => import('src/views/UserManagementUsers'))
      },{
        path: '/users/permissions',
        exact: true,
        component: lazy(() => import('src/views/UsersPermissions'))
      },{
        path: '/users/permissions/:id',
        exact: true,
        component: lazy(() => import('src/views/UsersPermissions/UsersPermissionsDetails'))
      },{
        path: '/users/roles',
        exact: true,
        component: lazy(() => import('src/views/UserManagementRoles'))
      },{
        path: '/users/roles/:id',
        exact: true,
        component: lazy(() => import('src/views/UsersRoles/UsersRolesDetails'))
      },{
        path: '/users/users',
        exact: true,
        component: lazy(() => import('src/views/UserManagementUsers'))
      },{
        path: '/users/users/:id',
        exact: true,
        component: lazy(() => import('src/views/UsersUsers/UsersUsersDetails'))
      },
      /* END_ROUTES */









      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  }
]
